import React from "react";
import Img from "../../../assets/app-only/images/public-layout-background.png";
import './index.scss'

const LoginIllustrations: React.FC = () => (
  <div className="illustration-background-container">
    {/* <img src={Img} className="w-100 h-100" /> */}
    <video className="w-101 h-100" autoPlay loop muted>
      <source src="/assets/videos/layout-video.webm" type="video/webm" />
    </video>
    <div className="illustration-overlay"></div>
  </div>
);

export default LoginIllustrations;